import { createApp, ref, onMounted, onUnmounted } from "vue"
import axios from "axios"
import LocationSelector from "../components/LocationSelector.vue"

createApp({
    components: {
        LocationSelector,
    },
    setup() {
        const isMenuOpen = ref(false)

        const toggleMenu = () => {
            isMenuOpen.value = !isMenuOpen.value
        }

        const closeDropdown = (event) => {
            const menu = document.querySelector(".navbar")
            if (menu && !menu.contains(event.target)) {
                isMenuOpen.value = false
            }
        }

        onMounted(() => {
            document.addEventListener("click", closeDropdown)
        })

        onUnmounted(() => {
            document.removeEventListener("click", closeDropdown)
        })

        return {
            isMenuOpen,
            toggleMenu,
        }
    },
}).mount("#header")
